import { Component, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { Overlay } from '@angular/cdk/overlay';
import { MatDialog } from '@angular/material';

import { AutocompleteSelectFieldComponent } from './autocomplete-select-field.component';
import { WorkflowsService } from '../workflows/workflows.service';

@Component({
  selector: 'app-nrg-terms-field',
  templateUrl: './autocomplete-select-field.component.html',
  styleUrls: ['./autocomplete-select-field.component.scss']
})
export class NrgTermsFieldComponent extends AutocompleteSelectFieldComponent {

  debounce: number = 400;
  path: string;
  subscription: Subscription;
  
  constructor(
    cd: ChangeDetectorRef,
    dialog: MatDialog,
    overlay: Overlay,
    private workflowsService: WorkflowsService) { super(cd, dialog, overlay); }

  ngOnInit() {
    super.ngOnInit();
    this.path = this.field.path;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.subscription != null) {this.subscription.unsubscribe()}
  }

  setMatchRegex(value) {
    if (value != null && value.trim() !== '')  {
      if (value.length < 3) {
        this.matchRegex = new RegExp('(^' + value.regExpEscape() + ')', 'gi');
      } else {
        this.matchRegex = new RegExp('(' + value.regExpEscape() + ')', 'gi');
      }
    } else {
      this.matchRegex = null;
    }
  }

  loadSuggestions(value) {
    if (this.subscription != null) {this.subscription.unsubscribe()}
    if (this.path != null && value != null && value.trim() !== '') {
      this.subscription = this.workflowsService.getNrgTerms(this.path, value, 8).subscribe(
        (data: any) => {
          this.suggestions = data.map((t) => {
            let displayed = t.term_value.replace("â??", "'").toTitleCase();
            return {
              displayed: displayed,
              stored: t.term_id
            }
          })
          if (this.suggestions.length > 0) {
            this.selectedIndex = 0;
            this.showSuggestions();
          }
          this.loading = false;
          this.cd.markForCheck();
        },
        (errors) => {this.loading = false; this.cd.markForCheck();}
      )
    } else {
      this.loading = false;
      this.cd.markForCheck();
    }
  }

  commitSelected() {
    if (this.subscription != null) {this.subscription.unsubscribe()}
    this.loading = false;
    this.cd.markForCheck();
    super.commitSelected();
  }

}


// WEBPACK FOOTER //
// ./src/app/forms/nrg-terms-field.component.ts